import { motion } from "framer-motion";
import { Shield, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useState, useEffect } from "react";

const HeroSection = () => {
  const evilWord = "EVIL";
  const markhorsWord = "MARKHORS";

  const [typedEvil, setTypedEvil] = useState("");
  const [typedMarkhors, setTypedMarkhors] = useState("");
  const [headingDone, setHeadingDone] = useState(false);

  const [whoamiText, setWhoamiText] = useState("");
  const [showCursor, setShowCursor] = useState(true);
  const [showHeadingCursor, setShowHeadingCursor] = useState(true);

  useEffect(() => {
    let i = 0;
    const t1 = setInterval(() => {
      if (i < evilWord.length) {
        setTypedEvil(evilWord.slice(0, i + 1));
        i++;
      } else {
        clearInterval(t1);
        let j = 0;
        const t2 = setInterval(() => {
          if (j < markhorsWord.length) {
            setTypedMarkhors(markhorsWord.slice(0, j + 1));
            j++;
          } else {
            clearInterval(t2);
            setHeadingDone(true);
            setShowHeadingCursor(false);
          }
        }, 80);
      }
    }, 100);
    return () => clearInterval(t1);
  }, []);

  useEffect(() => {
    if (!headingDone) return;
    const fullText = "$ whoami";
    let i = 0;
    const interval = setInterval(() => {
      if (i < fullText.length) {
        setWhoamiText(fullText.slice(0, i + 1));
        i++;
      } else {
        clearInterval(interval);
      }
    }, 120);
    return () => clearInterval(interval);
  }, [headingDone]);

  useEffect(() => {
    const blink = setInterval(() => setShowCursor((c) => !c), 500);
    return () => clearInterval(blink);
  }, []);

  const isFullyTyped = typedEvil === evilWord && typedMarkhors === markhorsWord;

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="relative z-10 text-center px-4 max-w-4xl mx-auto">
        <div>
          {/* Reserve full h1 space with invisible text, overlay typed text */}
          <h1
            className={`text-5xl sm:text-7xl font-bold font-mono mb-2 tracking-tight flex flex-wrap items-center justify-center gap-x-4 gap-y-2 min-h-[3rem] sm:min-h-[5rem] ${isFullyTyped ? " glitch-hover" : ""}`}
            data-text="EVIL MARKHORS"
            aria-label="EVIL MARKHORS"
          >
            <span className="text-primary text-glow">{typedEvil}</span>
            <span className="text-secondary text-glow-red">{typedMarkhors}</span>
            {!headingDone && (
              <span className={`text-primary transition-opacity duration-100 ${showCursor ? "opacity-100" : "opacity-0"}`}>▌</span>
            )}
          </h1>

          {/* Fixed height for whoami line */}
          <div className="font-mono text-muted-foreground text-sm mb-4 h-6">
            {whoamiText}
            {headingDone && (
              <span className={showCursor ? "opacity-100" : "opacity-0"}>▌</span>
            )}
          </div>

          {/* Use opacity + visibility instead of conditional mount for subtitle */}
          <p
            className="text-foreground text-lg sm:text-xl font-mono mt-4 mb-6 transition-opacity duration-500"
            style={{ opacity: headingDone ? 1 : 0 }}
          >
            Premium Cybersecurity & SMM Panel Services
          </p>
          <h2 className="sr-only">Pakistani Cybersecurity & SMM Panel Services — Penetration Testing, Vulnerability Assessment, Digital Forensics & SMM Panel Pakistan</h2>

          {/* Always render logo container with fixed dimensions */}
          <div style={{ perspective: '1000px' }} className="flex justify-center mb-8 h-[221px]">
            <img
              src="/images/evil-markhors-logo.webp"
              alt="Evil Markhors Services Logo — Pakistan's Best SMM Panel and Cybersecurity Agency"
              width={354}
              height={442}
              className="w-44 h-[221px] animate-logo-spin drop-shadow-[0_0_20px_rgba(0,204,0,0.5)] transition-opacity duration-600"
              style={{ opacity: headingDone ? 1 : 0 }}
            />
          </div>

          {/* Always render buttons, just toggle opacity */}
          <div
            className="flex flex-col sm:flex-row gap-4 justify-center transition-opacity duration-500"
            style={{ opacity: headingDone ? 1 : 0 }}
          >
            <Button
              size="lg"
              className="font-mono bg-primary text-primary-foreground hover:bg-primary/80 border-glow"
              asChild
            >
              <a href="#contact">
                <Shield className="w-4 h-4 mr-2" />
                Request Service
              </a>
            </Button>
            <Button
              variant="outline"
              size="lg"
              className="font-mono border-primary text-primary hover:bg-primary/10"
              asChild
            >
              <a href="#services">
                Explore Services
                <ChevronRight className="w-4 h-4 ml-2" />
              </a>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
